import { Typography } from "@mui/material";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";

function GeneralError({ text }) {
  const [showError, setShowError] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setShowError(false);
    }, 2000);
  }, []);

  return (
    <>
      {showError && (
        <div
          className="animation-top"
          style={{
            display: "flex",
            position: "absolute",
            bottom: "15%",
            right: "10%",
            alignItems: "center",
            borderRight: "6px solid",
            color: "rgba(212, 22, 79, 1)",
            background: "rgba(251, 232, 238, 1)",
            padding: "1rem",
          }}
        >
          <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.9998 7.33317C15.5521 7.33317 15.9998 7.78089 15.9998 8.33317V16.3332C15.9998 16.8855 15.5521 17.3332 14.9998 17.3332C14.4476 17.3332 13.9998 16.8855 13.9998 16.3332V8.33317C13.9998 7.78089 14.4476 7.33317 14.9998 7.33317Z"
              fill="#D4164F"
            />
            <path
              d="M14.9998 21.6665C15.7362 21.6665 16.3332 21.0695 16.3332 20.3332C16.3332 19.5968 15.7362 18.9998 14.9998 18.9998C14.2635 18.9998 13.6665 19.5968 13.6665 20.3332C13.6665 21.0695 14.2635 21.6665 14.9998 21.6665Z"
              fill="#D4164F"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M0.666504 14.9998C0.666504 7.08376 7.08376 0.666504 14.9998 0.666504C22.9159 0.666504 29.3332 7.08376 29.3332 14.9998C29.3332 22.9159 22.9159 29.3332 14.9998 29.3332C7.08376 29.3332 0.666504 22.9159 0.666504 14.9998ZM14.9998 2.6665C8.18833 2.6665 2.6665 8.18833 2.6665 14.9998C2.6665 21.8113 8.18833 27.3332 14.9998 27.3332C21.8113 27.3332 27.3332 21.8113 27.3332 14.9998C27.3332 8.18833 21.8113 2.6665 14.9998 2.6665Z"
              fill="#D4164F"
            />
          </svg>
          <Typography fontSize={"14px"} fontFamily={"500"} padding={'0 2rem'}>
            {text}
          </Typography>
        </div>
      )}
    </>
  );
}

export default GeneralError;
